/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MedCrossIcon20Solid = forwardRef('MedCrossIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M8.25 2C7.56 2 7 2.56 7 3.25V7H3.25C2.56 7 2 7.56 2 8.25v3.5c0 .69.56 1.25 1.25 1.25H7v3.75c0 .69.56 1.25 1.25 1.25h3.5c.69 0 1.25-.56 1.25-1.25V13h3.75c.69 0 1.25-.56 1.25-1.25v-3.5C18 7.56 17.44 7 16.75 7H13V3.25C13 2.56 12.44 2 11.75 2h-3.5Z" })));
});
